import React from 'react'
import Popup from '../components/Popup'
import { ProductSeries } from '../types/productTypes'
import './SelectSeriesPopup.scss'
import { PUBLIC_URL } from '../environment'

interface SelectSeriesProps {
  handleChooseSeries: (series: ProductSeries) => void
}

const SelectSeriesPopup: React.FC<SelectSeriesProps> = (props) => {

  const { handleChooseSeries } = props

  return (
    <Popup style={{ maxWidth:'none',width:'auto' }} onClose={() => { return }}>
      <div className="SelectSeriesPopup center">
        <div className="title center">
          Select a product range to get started:
        </div>
        <div className="deck">
          <div className="card" onClick={() => { handleChooseSeries(ProductSeries.Pro) }}>
            <img className="cardTop" src={`${PUBLIC_URL}/promo/Range_ProSeries.png`} alt="Iconic, Styl, and Essence switches on a wall." />
            <div className="cardBody">
              <strong>Pro Series</strong>
            </div>
          </div>
          <div className="card" onClick={() => { handleChooseSeries(ProductSeries.Iconic) }}>
            <img className="cardTop" src={`${PUBLIC_URL}/promo/Range_Iconic.png`} alt="A black and a white Pro Series switch." />
            <div className="cardBody">
              <strong>Iconic</strong>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  )
}

export default SelectSeriesPopup
